import React from 'react';

export const FormContainer: React.FC<any> = ({ children }) => {
    return (
        <div className="shadow overflow-hidden sm:rounded-md">
            <div className="bg-white px-8 py-6">
                {children}
            </div>
        </div>
    )
}
